import { FeatureFlagOptions } from './types'

const JUSIA_PUBLICATION_VARIANTS = {
  MODEL_SUGGESTIONS: 'model_suggestions',
  MODEL_USE: 'model_use',
} as const

export const DOCVIEW_MODEL_JUSIA_FLAG = {
  FEATURE_FLAG: 'docview_model_jusia',
  VARIANTS: JUSIA_PUBLICATION_VARIANTS,
} as const

export const DOCVIEW_MOTION_JUSIA_FLAG = {
  FEATURE_FLAG: 'docview_motion_jusia',
  VARIANTS: JUSIA_PUBLICATION_VARIANTS,
} as const

export const GROWTH_BOOK_FEATURE_FLAGS: Record<string, FeatureFlagOptions> = {
  DOCVIEW_MODEL_JUSIA: {
    name: DOCVIEW_MODEL_JUSIA_FLAG.FEATURE_FLAG,
    values: Object.values(JUSIA_PUBLICATION_VARIANTS),
  },
  DOCVIEW_MOTION_JUSIA: {
    name: DOCVIEW_MOTION_JUSIA_FLAG.FEATURE_FLAG,
    values: Object.values(JUSIA_PUBLICATION_VARIANTS),
  },
} as const
